const BASE_URL = process.env.REACT_APP_API_URL;
const BRIDGE_ENDPOINT = "/api/v1/identity/auth_bridge/bridge";
const EXCHANGE_ENDPOINT = "/api/v1/identity/auth_bridge/exchange";

export const authBridgeLogin = async (target, exchangeToken = null) => {
  try {
    const body = { target };
    if (exchangeToken) {
      body.exchange_token = exchangeToken;
    }

    const response = await fetch(`${BASE_URL}${BRIDGE_ENDPOINT}`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    return null;
  } catch (error) {
    console.error("Auth bridge login failed:", error);
    return null;
  }
};

export const getAuthBridgeExchangeToken = async (currentToken) => {
  try {
    const response = await fetch(`${BASE_URL}${EXCHANGE_ENDPOINT}`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${currentToken}`,
      },
    });

    if (response.ok) {
      const data = await response.json();
      return data.exchange_token;
    }

    return null;
  } catch (error) {
    console.error("Failed to get exchange token:", error);
    return null;
  }
};